import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    deleteConfirmation: (c?: {
        name: string;
    }) => string | React.ReactNode;
    deleteConfirmationButton: string;
    deleteTitle: string;
    deleteToast: (c?: {
        name: string;
    }) => string | React.ReactNode;
    deleteToastError: (c?: {
        name: string;
    }) => string | React.ReactNode;
};
export type Deps = {
    Box: any;
    Text: any;
};
export default {
    DEFINE(_messages: Text, { Box, Text }: Deps): void {
        return Object.defineProperties(this, {
            /** Confirmation dialog body text for deleting a collection */
            deleteConfirmation: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (c?: {
                        name: string;
                    }) => { const name = c?.name ?? ""; return __intl__.intl().formatMessage({ id: "useDeleteCollection.deleteConfirmation.0?c=2w0xvkak9nko", defaultMessage: "<jsx><Box><Text>Are you sure you want to delete  ''<Text1>{name}</Text1>''? No assets will be deleted and you can still access them in their respective folders.</Text></Box> <Text>Any Shares associated with this Collection will also be deleted.</Text></jsx>" }, { jsx: (__children__: React.ReactNode) => React.Children.toArray(__children__), Box: (__children__: React.ReactNode) => <Box paddingBottom={24}>{React.Children.toArray(__children__)}</Box>, Text: (__children__: React.ReactNode) => <Text color="tertiary">{React.Children.toArray(__children__)}</Text>, Text1: (__children__: React.ReactNode) => <Text color="primary" display="inline">{React.Children.toArray(__children__)}</Text>, name: name }); });
                },
                enumerable: true,
                configurable: true
            },
            /** Confirmation dialog action label */
            deleteConfirmationButton: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useDeleteCollection.deleteConfirmationButton?c=7nzkz7owpk0x", defaultMessage: "Delete" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Confirmation dialog title */
            deleteTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useDeleteCollection.deleteTitle?c=2wos57on8clal", defaultMessage: "Delete Collection" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Toast title shown when deletion succeeds */
            deleteToast: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (c?: {
                        name: string;
                    }) => { const name = c?.name ?? ""; return __intl__.intl().formatMessage({ id: "useDeleteCollection.deleteToast.0?c=36jmqkjv4nxui", defaultMessage: "Successfully deleted collection ''{name}''" }, { name: name }); });
                },
                enumerable: true,
                configurable: true
            },
            /** Toast title shown when deletion fails */
            deleteToastError: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (c?: {
                        name: string;
                    }) => { const name = c?.name ?? ""; return __intl__.intl().formatMessage({ id: "useDeleteCollection.deleteToastError.0?c=396c9gvdm2u63", defaultMessage: "Failed to delete collection ''{name}''" }, { name: name }); });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps: Deps): void;
};
